
import { Component, Vue, Ref } from 'vue-property-decorator'
import { ContactService } from '@/services'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'reporter-table',
    components: {
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageIndex = 1
    private pageTotal = 0
    private pageSize = 50
    private list = []
    private userId!: string
    private claimStatus = {
        0: '未认领',
        1: '已认领'
    }
    private typeStatus = {
        1: '报料',
        2: '邀请',
        3: '反馈问题'
    }

    created() {
        this.userId = this.$route.params.id
    }
    mounted() {
        this.getReportToReporter()
    }
    onStatusMap(row: any, col: any, value: any) {
        const map = {
            1: '未跟进',
            2: '跟进中',
            3: '跟进完成',
            4: '无需跟进'
        }
        return Reflect.get(map, value)
    }
    // 向记者报料
    async getReportToReporter() {
        const params = {
            user_id: this.userId,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await ContactService.getContacts(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.list = result.data.contacts
        }
    }

    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getReportToReporter)
    }
}
